<div class="flex flex-column h-full w-full overflow-auto" #logWrapper>
    @if(loadedLogs.length){
            @for (log of loadedLogs; track index; let index = $index){
                <div [innerHtml]="log" class="p-3" [class.uneven]="index % 2" #batchLog></div>
            }
    }
    @else{
        <div class="flex justify-content-center align-items-center h-full w-full">
            <p-progressSpinner styleClass="w-2rem h-2rem" aria-label="Loading" />
        </div>
    }
</div>
